import React from 'react';
import Lottie from 'react-lottie-player';

const AnimationRenderer = (props) => {
  return (
    <div>
      <Lottie
        loop
        play
        animationData={props.animationJSON.default}
        style={{ width: props.dimension, height: props.dimension }}
        rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
      />
    </div>
  );
};
export default AnimationRenderer;
